import { useEffect, useMemo, useState } from "react";
import { message,Upload } from "antd";
import { createAssistantWithFiles, updateAssistantWithDetailsAndFiles } from "../api/assistant";
import {
  retrievalFileTypes,
  codeInterpreterFileTypes,
} from "../constants/FileLIstConstants";

import { FileContext } from "../contexts/FileContext";
import { useContext } from "react";
const useAssistantFileUpload = (onDeleteFile, selectedTools, getInitialFiles) => {
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [countTotalFile, setCountTotalFile] = useState(0)
  const [totalFileList,setTotalFileList] = useState([]);
  const {  deletedFileList,setDeletedFileList, deleteFileIds, setDeleteFileIds} = useContext(FileContext);
  useEffect(() => {
    const initialFiles = getInitialFiles();
    const fileListFormatted = initialFiles.map((file, index) => ({
      uid: `existing-${index}`,
      name: file,
      status: "done",
    }));
    setFileList(fileListFormatted);
  }, [getInitialFiles]);

  // Compute allowed file types, accept string, and upload permission
  const { allowedFileTypes, accept, isUploadAllowed } = useMemo(() => {
    let types = [];
    const flatSelectedTools = Array.isArray(selectedTools) ? selectedTools.flat() : selectedTools;

    if (flatSelectedTools.includes("code_interpreter")) {
      types = [...types, ...codeInterpreterFileTypes];
    }
    if (flatSelectedTools.includes("file_search")) {
      types = [...types, ...retrievalFileTypes];
    }
    const uniqueTypes = [...new Set(types.map(type => type.toLowerCase()))];
    return {
      allowedFileTypes: uniqueTypes,
      accept: uniqueTypes.join(","), // e.g., ".csv,.txt"
      isUploadAllowed: uniqueTypes.length > 0, // True if any tools enable file uploads
    };
  }, [selectedTools]);


  const handleCreateOrUpdateAssistantWithFiles = async (
    formData,
    editMode,
    assistantId
  ) => {
    try {
      setUploading(true);

      const response = editMode
        ? await updateAssistantWithDetailsAndFiles(assistantId, formData)
        : await createAssistantWithFiles(formData);

      if (response.data) {
        message.success(
          response.message
        );
        return true;
      }
    } catch (error) {
      setTimeout(() => {
        message.error(error?.response?.data?.message || error.message);
      }, 0);
      return false;
    } finally {
      setDeletedFileList([])
      setUploading(false);
    }
  };

  const handleRemoveFile = (file) => {
    const newFileList = fileList.filter((f) => f.uid !== file.uid);
    const newTotalFileList = totalFileList.filter((f) => f.uid !== file.uid);

    setFileList(newFileList);
    setTotalFileList(newTotalFileList);
    // setDeletedFileList((prev)=>[...prev,file.uid]);
    setDeleteFileIds((prev)=>[...prev,file.uid]);

    if (file.uid.startsWith("existing")) {
      const index = parseInt(file.uid.split("-")[1], 10);
      onDeleteFile(index);
    }
  };
  const handleAddFile = (file, fileList) => {
    if (countTotalFile > 20) {
      return false;

    }
    const fileExtension = `.${file.name.split(".").pop().toLowerCase()}`;
    let allowedFileTypes = [];

    const flatSelectedTools = Array.isArray(selectedTools)
      ? selectedTools.flat()
      : selectedTools;

    if (flatSelectedTools.includes("code_interpreter")) {
      allowedFileTypes = [...allowedFileTypes, ...codeInterpreterFileTypes];
    }
    if (flatSelectedTools.includes("file_search")) {
      allowedFileTypes = [...allowedFileTypes, ...retrievalFileTypes];
    }

    const uniqueAllowedFileTypes = [
      ...new Set(allowedFileTypes.map((type) => type.toLowerCase())),
    ];
    const isFileAllowed = uniqueAllowedFileTypes.includes(fileExtension);

    if (!isFileAllowed) {
      message.error(`Unsupported file type: ${file.name}. Select supported file types for enabled tools.`);
      return Upload.LIST_IGNORE;
    }
    const existingFilenames = totalFileList.map((f) => f.name);
    if (existingFilenames.includes(file.name)) {
      message.error(`The file "${file.name}" already exists. Please upload a file with a unique name.`);
      return Upload.LIST_IGNORE;
    }
    // Only update state if file is valid
    setFileList((prevList) => [...prevList, file]);
    setTotalFileList((prevList) => [...prevList, file]);
    setCountTotalFile((prevCount) => prevCount + 1);
    return false;
  };

  const isUploading = () => uploading;

  return {
    handleCreateOrUpdateAssistantWithFiles,
    handleRemoveFile,
    handleAddFile,
    fileList,
    setFileList,
    isUploading,
    setCountTotalFile,
    countTotalFile,
    totalFileList,
    setTotalFileList,
    accept,           // For Upload component
    isUploadAllowed,  // For button disabling
    allowedFileTypes, // For displaying to user
    setTotalFileList,
    accept,           // For Upload component
    isUploadAllowed,  // For button disabling
    allowedFileTypes, // For displaying to user
  };
};

export default useAssistantFileUpload;
